//prettier-ignore
define('blockit',['require','exports','module','underscore','fukit/fukit'],function(require, exports, module) {
  var _     = require('underscore'),
      FuKit = require('fukit/fukit');

  // define local blocks here
  var localBlocks = {};

  var BlocKit = _.extend({}, FuKit.BlocKitShared, localBlocks)

  module.exports = BlocKit;
});

